<template>
    <m-basetabs :active="active" @update:active="val => $emit('update:active', val)">
        <template v-slot:tabs="{tabs}">
            <ul class="flex bg-gray-300 rounded-t-md" ref="ul">
                <li class="flex-1 text-black ml-2 text-center p-2 mt-1 cursor-pointer text-base rounded-t-md" v-for="(tab, index) in tabs"
                    :class="active == index ? ['bg-primary-600', 'text-white'] : ['bg-gray-300','hover_bg-gray-400']" ref="tablist"
                    @click="$emit('update:active',index)">
                    <m-ripple class="px-3 py-1 text-lg" color="#000"> {{ tab.text }}</m-ripple>
                </li>
            </ul>
        </template>
        <div class="p-4">
            <slot></slot>
        </div>
    </m-basetabs>
</template>

<script>
import BaseTabs from '../basecomponents/tabs.vue'

export default {
    components: {
        'm-basetabs': BaseTabs
    },
    props: {
        active: {
            type: Number,
            default: 0,
        }
    },
    name: 'tabs'
}
</script>
